import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { take, takeUntil } from "rxjs/operators";
import { CustomerCategory } from "../model/customer-categories.model";

@Component({
  selector: "ngx-customer-categories",
  templateUrl: "./customer-category-form.component.html",
  styleUrls: ["./customer-category-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerCategoryFormComponent extends BaseFormComponent<CustomerCategory> {
  erroremessage: string;
  deactivateSave: boolean = false;
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.apiName = "CustomerCategory";
    this.label = this.translate("ClientApp.FrontOffice.Parties.CustomerCategory.CustomerCategory");
    super.ngOnInit();
    this.FillData();
  }

  setdefault() {}

  addControl() {
    this.cd.markForCheck();
  }

  setMaxCode() {
    this.httpCommonService
      .getMaxCode(this.apiName)
      .pipe(take(1))
      .subscribe((data) => {
        if (!this.model) this.model = <CustomerCategory>{};
        if (data) this.model["Code"] = data as number;
        this.setFormGroup(this.model);
      });
  }

  async FillData() {
    const info = this.accountService.authService.currentInformation();
    if (info.BranchingLightEnabled || info.BranchingAdvancedEnabled) {
      const hasBranchCommunication = JSON.parse(localStorage.getItem("HasBranchCommunication"));
      if (hasBranchCommunication == null) {
        this.httpCommonService
          .getList(`Branch/HasBranchCommunication/${this.accountService.authService.currentBranchId}`)
          .pipe(take(1))
          .subscribe(
            async (hbc: boolean) => {
              if (hbc === true) {
                this.sts.showDialog(
                  this.translate("ClientApp.FrontOffice.Parties.CustomerCategory.HasBranchCommunication"),
                  this.translate("ClientApp.FrontOffice.Parties.CustomerCategory.Attention")
                );
                this.deactivateSave = true;
              }
            },
            (error) => this.getFailedHelper(error)
          );
      } else if (hasBranchCommunication) {
        this.sts.showDialog(
          this.translate("ClientApp.FrontOffice.Parties.CustomerCategory.HasBranchCommunication"),
          this.translate("ClientApp.FrontOffice.Parties.CustomerCategory.Attention")
        );
        this.deactivateSave = true;
      }
    }
  }
}
